import React from "react";
import TextEditorReader from "../../../../components/TextEditorReader/TextEditorReader";

const Text = ({ settings = {} }) => {
    return (
        <div className="text">
            <TextEditorReader text={settings.textInput}/>
        </div>
    );
};

export default Text;